<script lang="ts" context="module">
  export type SubmitEvent = { value: string; cancelLoading: () => void };
</script>

<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Modal from "./Modal.svelte";
  import Button from "$components/+design-system/Button/Button.svelte";
  import { alerts } from "$stores/alert";

  export let open: boolean;
  export let title: string;
  export let message = "";
  export let confirmLabel: string = "Confirm";
  export let value: string = "";
  export let loading: boolean = false;
  export let blankErrorMessage: string = "";

  /**
   * Cancel loading state of confirm/submit button
   */
  const cancelLoading = () => {
    loading = false;
  };

  $: if (!open) {
    cancelLoading();
  }

  const dispatch = createEventDispatcher<{
    submit: SubmitEvent;
  }>();
</script>

<Modal bind:open maxWidth="max-w-[400px]">
  <div class="flex flex-col gap-6 p-6">
    <h3 class="text-md font-medium text-gray-600 dark:text-gray-200">{title}</h3>
    {#if message}<p class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-300">
        {message}
      </p>{/if}

    <input
      bind:value
      type="text"
      class="w-full rounded-md border border-gray-300 bg-transparent p-2 text-gray-600 focus:border-gray-900/70 focus:outline-none dark:border-gray-500 dark:bg-gray-700/80 dark:text-gray-100 focus:dark:border-gray-400"
    />

    <div class="dark:transparent flex w-full gap-3 pt-2">
      <Button
        on:click={() => (open = false)}
        variant="secondary"
        label="Cancel"
        size="large"
        isFullWidth
      />
      <Button
        on:click={() => {
          // display error if input blank
          if (blankErrorMessage) {
            if (!value) {
              alerts.error(blankErrorMessage);
              loading = false;
              return;
            }
            loading = true;
            dispatch("submit", { value, cancelLoading });
          } else {
            loading = true;
            dispatch("submit", { value, cancelLoading });
            // clear input value after submit
          }
          value = "";
        }}
        variant="primary"
        size="large"
        label={confirmLabel}
        disabled={loading}
        isFullWidth
      />
    </div>
  </div>
</Modal>
